"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[4624],{

/***/ 74451:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  FirstProductModalView: () => (/* binding */ FirstProductModalView),
  "default": () => (/* binding */ FirstProductModal_FirstProductModal)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(35570);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__(83464);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(51497);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(72463);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__(6135);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__(8055);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(85183);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__(62100);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__(69453);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(43474);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(28950);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.fill.js
var es_array_fill = __webpack_require__(4130);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(66226);
// EXTERNAL MODULE: ./local_modules/local-storage/index.ts + 2 modules
var local_storage = __webpack_require__(55222);
// EXTERNAL MODULE: ./src/helpers/constants/index.ts + 8 modules
var constants = __webpack_require__(50556);
// EXTERNAL MODULE: ./src/modules/user/user/index.tsx + 1 modules
var user = __webpack_require__(17382);
// EXTERNAL MODULE: ./src/modules/products/useCatalogueId.ts + 2 modules
var useCatalogueId = __webpack_require__(7362);
// EXTERNAL MODULE: ./src/modules/products/useCatalogueProducts.ts + 1 modules
var useCatalogueProducts = __webpack_require__(69219);
// EXTERNAL MODULE: ./src/modules/products/useProducts.ts + 1 modules
var useProducts = __webpack_require__(55429);
// EXTERNAL MODULE: ./src/components/feedback/ModalHeadline/ModalHeadline.tsx
var ModalHeadline = __webpack_require__(45413);
// EXTERNAL MODULE: ./src/components/feedback/ModalButtons/ModalButtons.tsx
var ModalButtons = __webpack_require__(95325);
// EXTERNAL MODULE: ./src/components/feedback/PlainModal/PlainModal.tsx + 1 modules
var PlainModal = __webpack_require__(87586);
// EXTERNAL MODULE: ./src/components/inputs/Button/messages.ts
var messages = __webpack_require__(21182);
// EXTERNAL MODULE: ./src/compositions/productCards/ProductCardSmallSkeleton/ProductCardSmallSkeleton.tsx
var ProductCardSmallSkeleton = __webpack_require__(73095);
// EXTERNAL MODULE: ./src/compositions/productCards/ProductCardSmall/ProductCardSmall.tsx
var ProductCardSmall = __webpack_require__(80759);
;// CONCATENATED MODULE: ./src/compositions/modals/FirstProductModal/messages.ts
/* harmony default export */ const FirstProductModal_messages = ({
    title: {
        en: "Want to try something else?"
    },
    text: {
        en: "Add one of our best sellers for your first shipment."
    },
    "try": {
        en: "Let’s try this"
    },
    selected: {
        en: "Selected"
    },
    back: {
        en: "Go back"
    }
});

;// CONCATENATED MODULE: ./src/compositions/modals/FirstProductModal/FirstProductModal.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}


























var FirstProductModalView = function(props) {
    var selectedTradingItemId = props.selectedTradingItemId, onContinue = props.onContinue, closeModal = props.closeModal;
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    var _useState = _sliced_to_array((0,react.useState)(null), 2), selectedItem = _useState[0], setSelectedItem = _useState[1];
    var gender = (0,user/* useUser */.a)().gender;
    // TODO use picked items or recommendations in future - added on 2021-10-25 by maddoger
    var _useCatalogueId = (0,useCatalogueId/* default */.Z)({
        catalogueName: gender === "FEMALE" ? "perfumes" : "colognes"
    }), catalogueId = _useCatalogueId.catalogueId, isCatalogueFetching = _useCatalogueId.isFetching;
    var _useCatalogueProducts = (0,useCatalogueProducts/* default */.Z)({
        variables: {
            id: catalogueId,
            input: {
                filter: [
                    {
                        type: "CATEGORY",
                        filterValueIdList: [
                            "bestsellers"
                        ]
                    }
                ],
                offset: 0,
                limit: 12,
                productsFeed: "BESTSELLERS"
            }
        },
        skip: !catalogueId
    }), data = _useCatalogueProducts.data, isProductsFetching = _useCatalogueProducts.isFetching;
    // we use all saved sources of products
    var postponedItems = local_storage/* default */.Z.getItem(constants/* default */.Z.localStorageNames.queuePendingProducts);
    var highPriorityProducts = local_storage/* default */.Z.getItem(constants/* default */.Z.localStorageNames.queueHighPriorityProducts);
    var lowPriorityProducts = local_storage/* default */.Z.getItem(constants/* default */.Z.localStorageNames.queueLowPriorityProducts);
    var postponedProductsIds = [].concat(highPriorityProducts, postponedItems, lowPriorityProducts).filter(Boolean).map(function(item) {
        return String(item.product.productId);
    });
    var _useProducts = (0,useProducts/* default */.Z)({
        variables: {
            input: {
                slugs: postponedProductsIds,
                pagination: {
                    limit: 12
                }
            }
        },
        skip: !(postponedProductsIds === null || postponedProductsIds === void 0 ? void 0 : postponedProductsIds.length)
    }), postponedProducts = _useProducts.products, isPostponedProductsFetching = _useProducts.isFetching;
    var isFetching = isCatalogueFetching || isProductsFetching || !catalogueId || isPostponedProductsFetching;
    var catalogueProducts = data === null || data === void 0 ? void 0 : data.products;
    var products = (0,react.useMemo)(function() {
        if (isFetching) {
            return null;
        }
        var result = [];
        var ignoreCatalogueProductsIds = [];
        // merge products preferring catalogue ones, because they have more info
        postponedProducts === null || postponedProducts === void 0 ? void 0 : postponedProducts.forEach(function(item) {
            var catalogueProduct = catalogueProducts.find(function(param) {
                var id = param.id;
                return id === item.id;
            });
            if (catalogueProduct) {
                ignoreCatalogueProductsIds.push(item.id);
                result.push(catalogueProduct);
            } else {
                result.push(item);
            }
        });
        catalogueProducts === null || catalogueProducts === void 0 ? void 0 : catalogueProducts.forEach(function(item) {
            if (!ignoreCatalogueProductsIds.includes(item.id)) {
                result.push(item);
            }
        });
        return result.filter(function(item) {
            var _item_tradingItems_items_, _item_tradingItems_items, _item_tradingItems;
            return (item === null || item === void 0 ? void 0 : (_item_tradingItems = item.tradingItems) === null || _item_tradingItems === void 0 ? void 0 : (_item_tradingItems_items = _item_tradingItems.items) === null || _item_tradingItems_items === void 0 ? void 0 : (_item_tradingItems_items_ = _item_tradingItems_items[0]) === null || _item_tradingItems_items_ === void 0 ? void 0 : _item_tradingItems_items_.section) === "Subscription";
        }).slice(0, 12);
    }, [
        isFetching,
        catalogueProducts,
        postponedProducts
    ]);
    var handleContinue = function() {
        var _selectedItem_tradingItems_items, _selectedItem_tradingItems;
        var volume = ((_selectedItem_tradingItems = selectedItem.tradingItems) === null || _selectedItem_tradingItems === void 0 ? void 0 : (_selectedItem_tradingItems_items = _selectedItem_tradingItems.items) === null || _selectedItem_tradingItems_items === void 0 ? void 0 : _selectedItem_tradingItems_items[0]).volume;
        (0,analytics/* track */.j)("First product change", {
            productId: selectedItem.id,
            productGender: selectedItem.gender,
            productFullName: selectedItem.fullName,
            productBrand: selectedItem.brandInfo.name,
            productCategory: selectedItem.category,
            productVolume: volume ? "".concat(volume.volume, " ").concat(volume.unit) : undefined
        });
        onContinue(selectedItem);
        closeModal();
    };
    // if selected product is among products, we should pre-select it
    (0,react.useEffect)(function() {
        if (products) {
            var selectedProduct = products.find(function(param) {
                var tradingItems = param.tradingItems;
                var _tradingItems_items;
                return (tradingItems === null || tradingItems === void 0 ? void 0 : (_tradingItems_items = tradingItems.items) === null || _tradingItems_items === void 0 ? void 0 : _tradingItems_items[0].id) === selectedTradingItemId;
            });
            if (selectedProduct) {
                setSelectedItem(selectedProduct);
            }
        }
    }, [
        products,
        selectedTradingItemId
    ]);
    var buttonsClassName = (0,clsx/* default */.Z)("sticky bottom-0 z-floating-header", isMobile ? "-mx-16 -mb-16 mt-32 bg-gold-30 pb-32" : "-mx-40 -mb-40 bg-gray-10 p-40");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalHeadline/* default */.Z, {
                title: FirstProductModal_messages.title,
                text: FirstProductModal_messages.text
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid grid-cols-2 gap-16",
                children: isFetching ? new Array(6).fill(null).map(function(value, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardSmallSkeleton/* default */.Z, {}, index);
                }) : products === null || products === void 0 ? void 0 : products.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardSmall/* default */.Z, {
                        data: item,
                        withoutLink: true,
                        buttonProps: {
                            type: "custom",
                            title: FirstProductModal_messages["try"],
                            addedMessage: FirstProductModal_messages.selected,
                            isAdded: selectedItem === item,
                            onClick: function() {
                                setSelectedItem(item);
                            }
                        }
                    }, item.id);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalButtons/* default */.Z, {
                className: buttonsClassName,
                primary: {
                    title: messages/* default */.Z["continue"],
                    fullWidth: true,
                    disabled: !selectedItem,
                    onClick: handleContinue
                }
            })
        ]
    });
};
var FirstProductModal = function(props) {
    var name = props.name, closeModal = props.closeModal, selectedTradingItemId = props.selectedTradingItemId, onContinue = props.onContinue;
    var isMobile = (0,useDevice/* default */.Z)().isMobile;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PlainModal/* default */.ZP, {
        type: isMobile ? "default" : "sidebar-right",
        closeModal: closeModal,
        "data-testid": name,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FirstProductModalView, {
            selectedTradingItemId: selectedTradingItemId,
            onContinue: onContinue,
            closeModal: closeModal
        })
    });
};
/* harmony default export */ const FirstProductModal_FirstProductModal = (FirstProductModal);


/***/ })

}]);